(() => {
  let savedMobileMarkup = null;
  let savedDesktopMarkup = null;
  const shopSection = document.querySelector(".js-shop");

  // This function is there for SEO purposes. It removes duplicate headings in the footer by keeping only the appropriate markup in the DOM.
  const toggleResponsiveMarkup = () => {
    const mobileMarkup = document.querySelector(".js-shop-mobile");
    const desktopMarkup = document.querySelector(".js-shop-desktop");

    if (window.innerWidth <= 1024) {
      if (desktopMarkup) {
        savedDesktopMarkup = desktopMarkup;
        desktopMarkup.remove();
      }

      if (!mobileMarkup && savedMobileMarkup) {
        document.body.appendChild(savedMobileMarkup);
        savedMobileMarkup = null;
      }
    } else {
      if (mobileMarkup) {
        savedMobileMarkup = mobileMarkup;
        mobileMarkup.remove();
      }

      if (!desktopMarkup && savedDesktopMarkup) {
        shopSection.appendChild(savedDesktopMarkup);
        savedDesktopMarkup = null;
      }
    }
  };

  const init = () => {
    toggleResponsiveMarkup();

    window.addEventListener("resize", toggleResponsiveMarkup);
  };

  init();
})();
